import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { SecurityService } from '../../../services/security/security.service';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { Parametros } from '../../../models/Parametros';

@Component({
  selector: 'app-parametro',
  templateUrl: './parametro.component.html',
  styleUrls: ['./parametro.component.scss']
})
export class ParametroComponent implements OnInit {

  user: any;
  ipAddress: any;
  loading: boolean = false;
  IdParametro: string;
  IdEmpresa: string;
  editar: boolean;

  abrirAgregarParametros: boolean = false;
  NombreEmpresa: string;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('ParametrosForm', { static: true }) ParametrosForm: NgForm;

  ParametrosList: any[] = [];
  selectedRow: number;
  UpdateParameter: any;

  displayedColumns: string[] = ['checked', 'idParametro', 'Codigo', 'Valor', 'Descripcion', 'Tipo_Parametro', 'Vigente_Desde', 'Estado'];
  ParametrosListdataSource = new MatTableDataSource<Parametros>(this.ParametrosList);
  pageSizeOptions = [10, 20, 30, 50, 100, 200];

  constructor(private activateRoute: ActivatedRoute,
    private router: Router,
    private securityService: SecurityService) {
    this.NombreEmpresa = sessionStorage.getItem('empresa');
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

  }

  ngOnInit() {
    if (this.user.id_empresa == 1) {
      this.obtenerParametros(this.securityService.idEmpresa);
    } else {
      this.obtenerParametros(this.user.id_empresa);
    }

  }

  rowClick(rowId) {
    this.selectedRow = rowId;
  }


  edited(Parametros2: any) {

    this.loading = true;
    Parametros2.NombreProyecto = "DigitalFactoring";
    Parametros2.Usuario = this.user.Usuario;
    Parametros2.Host = "INTRANET";
    Parametros2.ip = this.ipAddress.ip;
    Parametros2.canal = "W";
    console.log('Parametros2', Parametros2);
    this.securityService.ActualizarParametro(Parametros2)
      .subscribe(res => {
        this.UpdateParameter = res;
        Swal.fire({
          title: '¡Parametro Actualizado!',
          text: 'Se actualizó correctamente',
          type: 'success',
          heightAuto: false
        }).then(resp => {
          if (resp.value) {
            if (this.UpdateParameter.Codigo == "COLOR_SECUNDARIO") {
              sessionStorage.setItem('color', this.UpdateParameter.Valor);
              this.refresh();
            } else if (this.UpdateParameter.Codigo == "LOGO_EMPRESA") {
              this.refresh();
            } else if (this.UpdateParameter.Codigo == "COLOR_PRIMARIO") {
              sessionStorage.setItem('color2', this.UpdateParameter.Valor);
              this.refresh();
            } else {
              this.ngOnInit();
            }
            Swal.close();
          }
        });

        this.loading = false;
      },
        (err: HttpErrorResponse) => {
          Swal.fire({
            title: "Error",
            text: "Parametro no actualizado",
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
        }
      );
  }

  //}

  refresh() {
    this.loading = true;
    window.location.reload();
  }

  obtenerParametros(id: any) {
    this.loading = true;
    this.securityService.ObtenerParametros(id)
      .subscribe((res: any) => {
        this.ParametrosList = res;

        this.loading = false;

        this.ParametrosListdataSource = new MatTableDataSource(this.ParametrosList);
        this.ParametrosListdataSource.sort = this.sort;
        this.ParametrosListdataSource.paginator = this.paginator;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
      });
  }

  crearParametros() {
    this.IdEmpresa = "";
    this.abrirAgregarParametros = true;
  }

  CerrarPopUpParametro(click: boolean) {
    this.abrirAgregarParametros = false;
    this.ngOnInit();
    this.obtenerParametros(this.IdEmpresa);
  }
}
